import React, { useState } from 'react'
import Image from '../atoms/Image'
import { Product, ProductVariant } from '@interfaces/product'
import WishListButton from '../atoms/WishListButton'

interface ProductProps {
  product: Product
  selectedVariant: ProductVariant
}

const ProductCardSimple: React.FC<ProductProps> = ({ product, selectedVariant }) => {
  const { title, handle, variants } = product
  const [currentVariant] = useState(selectedVariant || variants?.[0])
  return (
    <div>
      <div className="relative rounded overflow-hidden aspect-square">
        <div className="absolute z-2 top-0 left-0 right-0 bg-gradient-metal border-b border-grey-2">
          <div className="flex items-center gap-x-1 py-1.5 px-1 md:p-1.5">
            <WishListButton product={product} selectedVariant={currentVariant} />
          </div>
        </div>
        <a href={handle ? (
          `/products/${handle}`
        ) : (
          `/products/${currentVariant.handle}?variant=${currentVariant.legacyResourceId}`
        )} className="absolute inset-0 z-1 bg-white flex mt-4" aria-label={title}>
          {currentVariant.image?.src ? (
            <Image
              alt={currentVariant.image.alt}
              src={currentVariant.image.src}
              srcWidths={{ sm: 640 }}
              height={800}
              width={640}
              wrapperClasses="w-full h-full object-contain"
              classes="w-full h-full object-contain"
            />
          ): (
            <Image
              alt={product.title}
              src={product.featured_image || ''}
              srcWidths={{ sm: 640 }}
              height={800}
              width={640}
              wrapperClasses="w-full h-full object-contain"
              classes="w-full h-full object-contain"
            />
          )}
        </a>
      </div>
      <div>
        {title && <h3 className="body-md font-bold mt-3 lg:mt-4">{title}</h3>}
      </div>
    </div>
  )
}

export default ProductCardSimple
